// extracted by mini-css-extract-plugin
module.exports = {"yybLogin":"YybLogin_yybLogin_2T2dB","qqBtn":"YybLogin_qqBtn_2oD9b","wxBtn":"YybLogin_wxBtn_2flUQ"};